import { LIGHTBOX_SLIDER } from '../../constants/settings';

class Lightbox {
  constructor() {
    this.initializers = [].slice.call(document.getElementsByClassName('lightbox-trigger'));
    this.destroyers   = null;
    this.lightboxEl = document.getElementById('lightbox');
    this.lightboxGalleryEl = document.getElementsByClassName('lightbox-gallery')[0];
    this.slickGallery = null;
    this.isActive = false;
    this.prevArrow = document.querySelector(this.selectors.prevArrow);
    this.nextArrow = document.querySelector(this.selectors.nextArrow);
    this.widthRequirement = 1024;
    this.buildInitializers();
  }

  selectors = {
    prevArrow: '[data-prev-arrow]',
    nextArrow: '[data-next-arrow]',
  };

  buildInitializers() {
    this.initializers.map((initializer, i) => {
      initializer.addEventListener('click', e => {
        if (parseInt($(window).width()) >= this.widthRequirement) {
          if (!this.isActive) {
            this.isActive = true;
            this.buildGallery(initializer);
            return this.openLightbox();
          }
        }
      })
    });
  }

  buildDestroyers() {
    this.destroyers.map((destroyer, i) => {
      destroyer.addEventListener('click', e => {
        if (this.isActive) {
          this.isActive = false;
          this.destroyGallery();
          return this.closeLightbox();
        }
      });
    });
  }

  initGallery() {
    let $lightboxGalleryEl = $(this.lightboxGalleryEl);
    $lightboxGalleryEl.slick(LIGHTBOX_SLIDER);
    this.slickGallery = $lightboxGalleryEl;
  }

  destroyGallery() {
    this.slickGallery.slick('unslick');
    this.slickGallery    = null;
    let lightboxGallery  = this.lightboxGalleryEl.cloneNode(false);
    this.lightboxEl.replaceChild(lightboxGallery, this.lightboxGalleryEl);
    this.lightboxGalleryEl = lightboxGallery;
  }

  buildGallery(targetEl) {
    // Get Lightbox Els
    let siblingNodeList    = targetEl.parentNode.children;
    let galleryEls         = [].slice.call(siblingNodeList).filter((el) => el.hasAttribute('data-image-url'));
    let targetIndex        = galleryEls.indexOf(targetEl);
    let lightboxGalleryEls = galleryEls.slice(targetIndex).concat(galleryEls.slice(0, targetIndex));

    if (galleryEls.length === 1) {
      this.hideArrows();
    } else {
      this.showArrows();
    }

    lightboxGalleryEls.map((el, i) => {
      // Build Nodes
      let childEls         = [].slice.call(el.children);
      let slide            = document.createElement('div');
      let imgWrapper       = document.createElement('div');
      let imgEl            = document.createElement('img');
      imgEl.src            = el.dataset.imageUrl;

      // Build Slide
      imgWrapper.classList.add('lightbox-destroy');
      imgWrapper.appendChild(imgEl);

      // Add Caption if it exists
      let imgCaption = childEls.find(el => el.classList.contains('img-caption-container'));
      if (imgCaption) {
        let captionClone = imgCaption.cloneNode(true);
        imgWrapper.appendChild(captionClone);
      }
      slide.appendChild(imgWrapper);

      // Append Els
      this.lightboxGalleryEl.appendChild(slide)

      // Setup Destroyers
      this.destroyers = [].slice.call(document.querySelectorAll('.lightbox-gallery'));
      this.buildDestroyers();
    });
  }

  hideArrows() {
    this.prevArrow.classList.add('hide');
    this.nextArrow.classList.add('hide');
  }

  showArrows() {
    this.prevArrow.classList.remove('hide');
    this.nextArrow.classList.remove('hide');
  }

  openLightbox() {
    this.initGallery();
    this.lightboxEl.classList.add('active');
  }

  closeLightbox() {
    this.lightboxEl.classList.remove('active');
  }
}

export default Lightbox;



// WEBPACK FOOTER //
// ./app/javascript/articles/lightbox/index.js